import React from "react";

const BS5_Syllabus = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Syllabus Component</h2>
      <p>This is the BS5_Syllabus component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Syllabus;
